import gsap from 'gsap';

export function initDropdownFilter() {
  const button = document.querySelector('.m-cat-dropdown__btn');
  const list = document.querySelector('.m-cat-dropdown__list');
  let open = false;

  if (button && list) {
    button.addEventListener('click', () => {
      if (open) {
      !open
        gsap.to(list, {
          translateY: 10,
          autoAlpha: 0,
          duration: 0.4,
          onComplete: () => { open = false }
        });
        button.classList.remove('open')
      } else {
        gsap.to(list, {
          translateY: 0,
          autoAlpha: 1,
          duration: 0.4,
          onComplete: () => { open = true }
        });
        button.classList.add('open')
      }
    });
  }
}
